/**
 * Set when retailer sends referral bonus follow-up message *
 */ export var HAS_SENT_REFERRAL_BONUS_FOLLOW_UP = 'HAS_SENT_REFERRAL_BONUS_FOLLOW_UP';
